<div class="flex flex-row justify-between pb-3 pr-2 relative items-center">
    <div class="flex flex-row items-center">
        <button mat-icon-button class="flex items-center justify-center" *ngIf="isSelectedOTPMethods"
            (click)="reSetAndBack()">
            <mat-icon class="text-blue-theme-color text-xl">arrow_back</mat-icon>
        </button>
        <h2 mat-dialog-title class="!pl-0 text-2xl !m-0 font-bold !text-blue-theme-color">{{this.isSelectedOTPMethods ?
            'OTP Verification' : 'Choose OTP Method'}}</h2>
    </div>
    <button mat-icon-button class="dialog-close-btn flex items-center justify-center" mat-dialog-close>
        <mat-icon class="text-blue-theme-color text-xl">close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mt-16 pt-4 !py-0">
    <div id="recaptcha-container"></div>

    <div class="w-full" *ngIf="!isSelectedOTPMethods">
        <div class="flex mt-6 w-full gap-4 justify-center items-center flex-col">
            <img src="assets/images/ui/otp.svg" class="w-[120px]" alt="">
            <span
                class="text-blue-theme-color text-center font-medium md:text-lg sm:text-base text-base !leading-6">Select
                your preferred method <br> to receive the OTP</span>
            <div class="flex flex-col gap-4 my-5 items-center w-full justify-center">
                <ng-container *ngFor="let item of OTPMethods">
                    <button (click)="onSelectOtpMethod(item)" class="px-3 py-2 border relative w-full rounded"
                        [ngClass]="item.isSelected ? 'border-blue-theme-color' : 'border-light-gray'" matRipple>
                        <div class="flex gap-1">
                            <div class="flex items-start gap-1 min-w-7">
                                <img [src]="item.icon" alt="" class="w-6 mt-1 aspect-square object-contain">
                            </div>
                            <div class="flex justify-start items-start flex-col">
                                <span class="text-base font-semibold"
                                    [ngClass]="item.isSelected ? 'text-blue-theme-color' : 'text-black-color'">{{item.title}}</span>
                                <ng-container *ngIf="item.id == 1">
                                    <p class="text-left font-semibold text-sm">Get a code on
                                        ({{this._data.phoneCode}}){{phoneNumberFormat(this._data.phoneNumber)}}</p>
                                    <span class="text-left font-normal text-sm text-[#7C8390]">Preferably, use a phone number that is
                                        active on both WhatsApp and for calls.</span>
                                </ng-container>
                                <ng-container *ngIf="item.id == 2">
                                    <p class="text-left font-semibold text-sm">Get a code on
                                        ({{this._data.phoneCode}}){{phoneNumberFormat(this._data.phoneNumber)}}</p>
                                </ng-container>
                                <ng-container *ngIf="item.id == 3">
                                    <p class="text-left font-semibold text-sm">Receive a call with the code on
                                        <br />({{this._data.phoneCode}}){{phoneNumberFormat(this._data.phoneNumber)}}
                                    </p>
                                </ng-container>
                            </div>
                        </div>

                        <!-- Recommended -->
                        <div *ngIf="item.isRecommended"
                            class="absolute top-0 right-0 font-light bg-green-color text-white-color flex items-center rounded-tr rounded-bl text-xs leading-[10px] px-2 py-1">
                            Recommended</div>

                    </button>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="w-full" *ngIf="isSelectedOTPMethods">
        <div class="flex mt-6 w-full gap-4 justify-center items-center flex-col">
            <img src="assets/images/ui/otp.svg" class="w-[120px]" alt="">
            <span
                class="text-blue-theme-color text-center font-medium md:text-lg sm:text-base text-base !leading-6">Please
                enter the 6-digit OTP<br> sent to your mobile number via {{this.selectedMethods.title}}</span>
            <button *ngIf="this.isErrorShow" color="primary" class="!bg-white-color underline !text-blue-theme-color"
                (click)="this.sendOTPViaWhatsApp()">Send otp on Whatsapp</button>

            <div class="flex justify-center mt-4">
                <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="config"></ng-otp-input>
            </div>
        </div>

        <div class="text-center">
            <button *ngIf="this.timeCounter != undefined && this.timeCounter != null" color="primary"
                (click)="this.timeCounter == 0 ? sendOTP() : null" class="!bg-white-color !text-blue-theme-color"
                mat-flat-button>
                <ng-container *ngIf="this.timeCounter == 0">
                    Resend Code
                </ng-container>
                <ng-container *ngIf="this.timeCounter != 0">
                    <ng-container>{{'Resend otp in ' + this.timeCounter + ' sec'}}</ng-container>
                </ng-container>
            </button>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions *ngIf="_data?.type != 'html'" class="mt-2 !pb-5 !px-0 justify-center">

    <ng-container *ngIf="!isSelectedOTPMethods">
        <button color="primary" [disabled]="checkSendOTPValidation()" (click)="this.sendOTP()"
            class="!bg-blue-theme-color md:!w-[130px] disabled:opacity-70 sm:!w-full !w-full !h-11 text-white-color"
            mat-flat-button>Send OTP</button>
    </ng-container>

    <ng-container *ngIf="isSelectedOTPMethods">
        <button color="primary" (click)="this.continue()"
            class="!bg-blue-theme-color md:!w-[130px] sm:!w-full !w-full !h-11 text-white-color"
            mat-flat-button>Verify</button>
    </ng-container>

</mat-dialog-actions>